<template>
  <PriorityFilter />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import PriorityFilter from "@/views/bugsInfo/components/PriorityFilter.vue"

  export default defineComponent({
    components: { PriorityFilter },
  })
</script>
